// extracted by mini-css-extract-plugin
module.exports = {"Campaign":"Campaign_Campaign__2zwLE","Image":"Campaign_Image__21f63"};